/* unplugin-vue-components disabled */import { render } from "./company-info.vue?vue&type=template&id=26176f8c&scoped=true"
import script from "./company-info.vue?vue&type=script&lang=js"
export * from "./company-info.vue?vue&type=script&lang=js"

import "./company-info.vue?vue&type=style&index=0&id=26176f8c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26176f8c"],['__file',"src/components/cards/company/company-info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26176f8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26176f8c', __exports__)) {
    api.reload('26176f8c', __exports__)
  }
  
  module.hot.accept("./company-info.vue?vue&type=template&id=26176f8c&scoped=true", () => {
    api.rerender('26176f8c', render)
  })

}


export default __exports__